export default __webpack_public_path__ + "static/media/plan-4.3352d508.jpg";